import React, { createContext, useContext, useEffect, useState } from "react";

// EN = English, MS = Bahasa Melayu. We keep the same key shape in both dictionaries.
// To add more strings, just add the same key in both en and ms below.
export const STRINGS = {
  en: {
    // header
    "nav.pathways":      "Pathways",
    "nav.opportunities": "Opportunities",
    "nav.vendor":        "Vendor",
    "nav.membership":    "Membership",
    "nav.coverage":      "Coverage",
    "header.signin":     "Sign In",
    "header.tagline":    "Make Money Today · Build A Business Tomorrow",

    // hero
    "hero.audience_badge": "For Malaysians who want side income, partnerships or to grow a business",
    "hero.tag":            "Malaysia's Entrepreneur Growth Platform",
    "hero.headline_1":     "Make Money Today.",
    "hero.headline_2":     "Build A Business",
    "hero.headline_3":     "Tomorrow.",
    "hero.sub":            "Discover verified income opportunities, business opportunities, influencers, partners and growth pathways through one platform.",
    "hero.cta_earn":       "Explore Income Opportunities",
    "hero.cta_start":      "Start A Business",
    "hero.cta_grow":       "Grow My Business",
    "hero.cta_explore":    "Start A Business",
    "hero.cta_list":       "Grow My Business",
    "hero.cta_tv":         "Watch Opportunity TV",
    "hero.check_1":        "100% free to start",
    "hero.check_2":        "5 income paths",
    "hero.check_3":        "All 16 Malaysian states",

    // opportunity TV preview
    "tv.live_badge":       "Live · Opportunity TV",
    "tv.headline_1":       "Real Malaysians.",
    "tv.headline_2":       "Real Earnings. On Video.",
    "tv.sub":              "Watch how housewives, students and small business owners are making money with MIRESCO — then start your own journey.",
    "tv.cta_watch":        "Watch Now",
    "tv.cta_post":         "Post Your Story",
    "tv.benefit_1_title":  "See Proof",
    "tv.benefit_1_desc":   "Real income stories, not stock photos.",
    "tv.benefit_2_title":  "Get Discovered",
    "tv.benefit_2_desc":   "Your 60-second video reaches thousands.",
    "tv.benefit_3_title":  "Start Free",
    "tv.benefit_3_desc":   "Tap. Watch. Apply. No paperwork.",

    // why join us
    "why.tag":     "Why MIRESCO",
    "why.heading": "Why thousands of Malaysians are joining.",
    "why.intro":   "We built MIRESCO BIZ for one reason — to put more money into more Malaysian hands. Here's what you get the moment you sign up.",
    "why.cta":     "Join Free Now",
    "why.b1_title": "Earn from day 1",
    "why.b1_desc":  "Affiliate links, agent commissions, kiosk income, vendor partnerships — pick one or stack them all.",
    "why.b2_title": "Just your phone",
    "why.b2_desc":  "Promote with a tap. Share WhatsApp links, post videos, close deals — everything works on mobile.",
    "why.b3_title": "Real community",
    "why.b3_desc":  "Join Malaysians who help each other grow. Learn from top earners, ask questions, share wins.",
    "why.b4_title": "Verified brands only",
    "why.b4_desc":  "Every opportunity is screened. No scams, no fake promises — only real Malaysian businesses.",
    "why.b5_title": "Grow your own brand",
    "why.b5_desc":  "Got a product? List as a vendor. Recruit affiliates, find agents, sell across all 16 states.",
    "why.b6_title": "All 16 states",
    "why.b6_desc":  "Connect with opportunities in your hometown — Johor to Sabah, KL to Sarawak. Find your turf.",

    // pathways
    "pathways.tag":  "Three pathways",
    "pathways.heading": "Pick the path that fits you.",
    "pathways.intro":   "Three clear ways to grow with MIRESCO — whether you have zero capital or a business to scale.",

    // featured opportunities
    "opps.tag":     "Featured",
    "opps.heading": "Featured opportunities",
    "opps.heading_live_pre":  "Live",
    "opps.heading_live":      "Live Business Opportunities",
    "opps.heading_live_hi":   "Business Opportunities",
    "opps.intro":   "Real Malaysian brands recruiting affiliates, agents, vendors and partners right now on MIRESCO BIZ.",
    "opps.intro_live":   "Real products, services and businesses you can join today.",
    "opps.view_showcase": "View showcase",
    "opps.apply_now":     "Apply now",
    "opps.whatsapp":      "WhatsApp",
    "opps.see_all":       "See all opportunities",

    // I Want To (Start here strip)
    "iwant.tag":      "Start here",
    "iwant.heading":  "What do you want to achieve",
    "iwant.today":    "today?",
    "iwant.intro":    "Tap any pathway — start earning or building today.",
    "iwant.explore":  "Explore",
    "iwant.wa_us":    "WhatsApp us",
    "iwant.loading":  "Loading pathways…",

    // Success stories carousel
    "success.tag":       "Real Stories · Real Income",
    "success.heading":   "People are earning with",
    "success.today":     "today",
    "success.intro":     "Affiliates, agents, stockists and creators — regular Malaysians building real income across the country.",
    "success.see_all":   "See all",
    "success.read_story":"Read story",
    "success.featured":  "Featured",
    "success.default_name": "MIRESCO Partner",

    // Opportunity Detail — 3 engagement tabs
    "opp.tab_business":  "Business Opportunity",
    "opp.tab_earn":      "Start Earning",
    "opp.tab_creator":   "Creator Campaign",
    "opp.tab_default_earn_heading":    "Start Earning with us",
    "opp.tab_default_creator_heading": "Creator Campaign",
    "opp.tab_empty":     "This tab hasn't been configured yet. The MIRESCO team will update it shortly.",
    "opp.tab_cta_earn_default":    "Start Earning",
    "opp.tab_cta_creator_default": "Apply as Creator",
    "opp.tab_follow_journey": "Follow the guided journey",
    "opp.back":          "Back",
    "opp.header_chat":   "Chat",
    "opp.hero_estimate": "Estimate income ↓",
    "opp.hero_join":     "How to join ↓",
    "opp.hero_faq":      "FAQ ↓",
    "opp.sec_summary":   "Business Summary",
    "opp.sec_overview":  "Opportunity Overview",
    "opp.sec_nature":    "Opportunity Nature",
    "opp.sec_revenue":   "Revenue Model",
    "opp.sec_invest":    "Investment Required",
    "opp.sec_income":    "Estimated Income",
    "opp.sec_model":     "Business Model",
    "opp.sec_reqs":      "Requirements",
    "opp.sec_training":  "Training",
    "opp.sec_videos":    "Videos",
    "opp.sec_photos":    "Photos",
    "opp.sec_testimonials": "Testimonials",
    "opp.sec_success":   "Success Stories",
    "opp.sec_faq":       "Frequently Asked Questions",
    "opp.apply_ready":   "Ready to start?",
    "opp.apply_heading": "Choose your path with",
    "opp.apply_sub":     "Tap any button below — we'll reply on WhatsApp within minutes.",
    "opp.not_found":     "Opportunity not found",
    "opp.loading":       "Loading opportunity…",
    "opp.back_home":     "Back to home",

    // Enquiry form
    "enq.title":         "Request a callback",
    "enq.name":          "Your name*",
    "enq.phone":         "WhatsApp number*",
    "enq.email":         "Email (optional)",
    "enq.message":       "Anything we should know? (optional)",
    "enq.opt_buy":       "I want to Buy",
    "enq.opt_affiliate": "Become an Affiliate",
    "enq.opt_agent":     "Become an Agent",
    "enq.opt_stockist":  "Become a Stockist",
    "enq.opt_general":   "General enquiry",
    "enq.submit":        "Request callback from",
    "enq.submitting":    "Sending…",
    "enq.err_required":  "Please enter your name and phone number.",
    "enq.done_title":    "Enquiry received",
    "enq.done_sub":      "Our team will contact you on WhatsApp within minutes.",
    "enq.done_toast":    "Thanks! We'll reach out on WhatsApp shortly.",
    "enq.footer":        "Or tap any button above to WhatsApp us instantly.",

    // Income calculator
    "calc.title":        "Estimate Your Income",
    "calc.retail":       "Retail price",
    "calc.cost":         "Your cost",
    "calc.units":        "Units sold / day",
    "calc.profit_unit":  "Profit / unit",
    "calc.daily":        "Estimated Daily",
    "calc.monthly":      "Estimated Monthly",

    // Landing page — misc sections
    "about.tag":         "About",
    "about.cta":         "Learn more",
    "categories.tag":    "Categories",
    "categories.heading":"Business categories",
    "categories.intro":  "Every kind of Malaysian business — pick the sector that matches your skills.",
    "journey.tag":       "Your journey",
    "journey.heading":   "The MIRESCO entrepreneur journey",
    "journey.intro":     "Six clear stages — from extra income to business leader.",
    "programs.tag":      "Programs",
    "programs.heading":  "Every persona has a home.",
    "programs.intro":    "Whoever you are, MIRESCO has a growth path built for you.",
    "membership.tag":    "Membership",
    "membership.heading":"Pick your tier · unlock benefits",
    "membership.intro":  "From free explorer to premium ambassador — grow with the tier that matches your ambition.",
    "coverage.tag":      "Coverage",
    "coverage.heading":  "All 16 Malaysian states",
    "coverage.intro":    "MIRESCO reaches every state in Malaysia — find opportunities in your area.",
    "coming.tag":        "Coming soon",
    "coming.heading":    "Exciting things ahead",
    "final.tag":         "Ready?",
    "final.heading":     "Start earning with MIRESCO today.",
    "final.sub":         "Join thousands of Malaysians turning ambition into income.",
    "final.cta_primary": "Join Free",
    "final.cta_secondary":"Chat on WhatsApp",

    // Footer
    "footer.tagline":    "Malaysia's entrepreneur growth platform",
    "footer.rights":     "All rights reserved.",

    // Journey Detail
    "jd.back":            "Dashboard",
    "jd.journey":         "journey",
    "jd.guided":          "Guided Journey",
    "jd.days":            "days",
    "jd.progress":        "Progress",
    "jd.reward":          "Reward",
    "jd.reward_step":     "Reward",
    "jd.mark_done":       "Mark done",
    "jd.saving":          "Saving…",
    "jd.open":            "Open",
    "jd.watch":           "Watch",
    "jd.download":        "Download",
    "jd.send_wa":         "Send WhatsApp",
    "jd.step_done_toast": "Step done — keep going!",
    "jd.not_found":       "Journey not found",
    "jd.loading":         "Loading journey…",
    "jd.back_dashboard":  "Back to dashboard",

    // PWA install prompt
    "pwa.install_title": "Install MIRESCO on your phone",
    "pwa.install_sub":   "Faster access, works offline, one-tap open.",
    "pwa.install_cta":   "Add to Home Screen",
    "pwa.dismiss":       "Dismiss",
    "pwa.ios_sub":       "Add MIRESCO to your Home Screen for one-tap access.",
    "pwa.ios_step_1":    "Tap Share",
    "pwa.ios_step_2":    "Tap Add to Home Screen",
    "pwa.ios_step_3":    "Tap Add · You're done!",

    // sidebar nav (inside app)
    "side.dashboard":     "Dashboard",
    "side.tv":            "Opportunity TV",
    "side.opportunities": "Opportunities",
    "side.applications":  "Applications",
    "side.territories":   "Territories",
    "side.influencers":   "Influencers",
    "side.membership":    "Membership",
    "side.notifications": "Notifications",
    "side.post_promo":    "Post Promo",
    "side.profile":       "Profile",
    "side.admin":         "Admin",
    "side.logout":        "Log Out",
    "side.portals":       "Portals",
  },
  ms: {
    "nav.pathways":      "Pilihan Anda",
    "nav.opportunities": "Peluang",
    "nav.vendor":        "Vendor",
    "nav.membership":    "Keahlian",
    "nav.coverage":      "Liputan",
    "header.signin":     "Log Masuk",
    "header.tagline":    "Buat Duit Hari Ini · Bina Bisnes Esok",

    "hero.audience_badge": "Untuk rakyat Malaysia yang ingin tambah pendapatan, cari rakan kongsi atau besarkan perniagaan",
    "hero.tag":            "Platform Pembangunan Usahawan Malaysia",
    "hero.headline_1":     "Buat Duit Hari Ini.",
    "hero.headline_2":     "Bina Bisnes",
    "hero.headline_3":     "Esok Hari.",
    "hero.sub":            "Temui peluang pendapatan, peluang bisnes, influencer, rakan kongsi dan jalan pertumbuhan — semua dalam satu platform.",
    "hero.cta_earn":       "Cari Peluang Pendapatan",
    "hero.cta_start":      "Mulakan Bisnes",
    "hero.cta_grow":       "Besarkan Bisnes Saya",
    "hero.cta_explore":    "Mulakan Bisnes",
    "hero.cta_list":       "Besarkan Bisnes Saya",
    "hero.cta_tv":         "Tonton Opportunity TV",
    "hero.check_1":        "100% percuma untuk mula",
    "hero.check_2":        "5 cara untuk dapat income",
    "hero.check_3":        "Semua 16 negeri di Malaysia",

    "tv.live_badge":       "Live · Opportunity TV",
    "tv.headline_1":       "Rakyat Malaysia Sebenar.",
    "tv.headline_2":       "Pendapatan Sebenar. Di Video.",
    "tv.sub":              "Tonton bagaimana suri rumah, pelajar dan peniaga kecil sedang buat duit dengan MIRESCO — kemudian mulakan perjalanan anda sendiri.",
    "tv.cta_watch":        "Tonton Sekarang",
    "tv.cta_post":         "Hantar Cerita Anda",
    "tv.benefit_1_title":  "Lihat Bukti",
    "tv.benefit_1_desc":   "Kisah pendapatan sebenar, bukan gambar stok.",
    "tv.benefit_2_title":  "Dapat Dilihat",
    "tv.benefit_2_desc":   "Video 60-saat anda dilihat ribuan orang.",
    "tv.benefit_3_title":  "Mula Percuma",
    "tv.benefit_3_desc":   "Tekan. Tonton. Mohon. Tanpa kertas kerja.",

    "why.tag":     "Kenapa MIRESCO",
    "why.heading": "Kenapa ribuan rakyat Malaysia sertai kami.",
    "why.intro":   "Kami bina MIRESCO BIZ atas satu sebab — letak lebih banyak duit dalam tangan rakyat Malaysia. Inilah yang anda dapat sebaik sahaja daftar.",
    "why.cta":     "Sertai Percuma Sekarang",
    "why.b1_title": "Buat duit dari hari pertama",
    "why.b1_desc":  "Pautan afiliasi, komisen ejen, pendapatan kiosk, perkongsian vendor — pilih satu atau gabungkan semua.",
    "why.b2_title": "Hanya guna telefon anda",
    "why.b2_desc":  "Promosi dengan satu tekanan. Kongsi pautan WhatsApp, hantar video, tutup deal — semua boleh dari mobile.",
    "why.b3_title": "Komuniti sebenar",
    "why.b3_desc":  "Sertai rakyat Malaysia yang saling membantu untuk berkembang. Belajar dari top earner, tanya soalan, kongsi kejayaan.",
    "why.b4_title": "Jenama yang disahkan",
    "why.b4_desc":  "Setiap peluang disaring. Tiada penipuan, tiada janji palsu — hanya bisnes Malaysia yang sebenar.",
    "why.b5_title": "Besarkan jenama anda",
    "why.b5_desc":  "Ada produk? Senaraikan sebagai vendor. Cari afiliasi, ejen, dan jual di seluruh 16 negeri.",
    "why.b6_title": "Semua 16 negeri",
    "why.b6_desc":  "Hubungkan dengan peluang di kampung anda — Johor ke Sabah, KL ke Sarawak. Cari wilayah anda.",

    "pathways.tag":     "Tiga pilihan",
    "pathways.heading": "Pilih jalan yang sesuai untuk anda.",
    "pathways.intro":   "Tiga cara jelas untuk berkembang bersama MIRESCO — sama ada anda tiada modal atau ada bisnes yang nak dibesarkan.",

    "opps.tag":     "Pilihan terbaik",
    "opps.heading": "Peluang pilihan",
    "opps.heading_live_pre":  "Peluang",
    "opps.heading_live":      "Peluang Bisnes Terkini",
    "opps.heading_live_hi":   "Bisnes Terkini",
    "opps.intro":   "Jenama Malaysia sebenar yang sedang mencari afiliasi, ejen, vendor dan rakan kongsi di MIRESCO BIZ.",
    "opps.intro_live":   "Produk, servis dan bisnes sebenar yang anda boleh sertai hari ini.",
    "opps.view_showcase": "Lihat showcase",
    "opps.apply_now":     "Mohon sekarang",
    "opps.whatsapp":      "WhatsApp",
    "opps.see_all":       "Lihat semua peluang",

    // I Want To (Start here strip)
    "iwant.tag":      "Mula di sini",
    "iwant.heading":  "Apa yang anda mahu capai",
    "iwant.today":    "hari ini?",
    "iwant.intro":    "Tekan mana-mana laluan — mula buat duit atau bina bisnes hari ini.",
    "iwant.explore":  "Terokai",
    "iwant.wa_us":    "WhatsApp kami",
    "iwant.loading":  "Sedang muat laluan…",

    // Success stories carousel
    "success.tag":       "Kisah Sebenar · Pendapatan Sebenar",
    "success.heading":   "Rakyat Malaysia sedang buat duit dengan",
    "success.today":     "hari ini",
    "success.intro":     "Afiliasi, ejen, stockist dan creator — rakyat Malaysia biasa yang bina pendapatan sebenar di seluruh negara.",
    "success.see_all":   "Lihat semua",
    "success.read_story":"Baca kisah",
    "success.featured":  "Pilihan",
    "success.default_name": "Rakan MIRESCO",

    // Opportunity Detail — 3 engagement tabs
    "opp.tab_business":  "Peluang Bisnes",
    "opp.tab_earn":      "Mula Dapat Income",
    "opp.tab_creator":   "Kempen Creator",
    "opp.tab_default_earn_heading":    "Mula Dapat Income dengan kami",
    "opp.tab_default_creator_heading": "Kempen Creator",
    "opp.tab_empty":     "Tab ini belum disiapkan. Pasukan MIRESCO akan kemas kini tidak lama lagi.",
    "opp.tab_cta_earn_default":    "Mula Dapat Income",
    "opp.tab_cta_creator_default": "Mohon Sebagai Creator",
    "opp.tab_follow_journey": "Ikuti jalan berpandu",
    "opp.back":          "Kembali",
    "opp.header_chat":   "Chat",
    "opp.hero_estimate": "Anggar pendapatan ↓",
    "opp.hero_join":     "Cara sertai ↓",
    "opp.hero_faq":      "Soalan Lazim ↓",
    "opp.sec_summary":   "Ringkasan Bisnes",
    "opp.sec_overview":  "Gambaran Peluang",
    "opp.sec_nature":    "Sifat Peluang",
    "opp.sec_revenue":   "Model Pendapatan",
    "opp.sec_invest":    "Modal Diperlukan",
    "opp.sec_income":    "Anggaran Pendapatan",
    "opp.sec_model":     "Model Bisnes",
    "opp.sec_reqs":      "Keperluan",
    "opp.sec_training":  "Latihan",
    "opp.sec_videos":    "Video",
    "opp.sec_photos":    "Gambar",
    "opp.sec_testimonials": "Testimoni",
    "opp.sec_success":   "Kisah Kejayaan",
    "opp.sec_faq":       "Soalan Lazim",
    "opp.apply_ready":   "Sedia untuk mula?",
    "opp.apply_heading": "Pilih jalan anda dengan",
    "opp.apply_sub":     "Tekan mana-mana butang di bawah — kami akan balas di WhatsApp dalam beberapa minit.",
    "opp.not_found":     "Peluang tidak dijumpai",
    "opp.loading":       "Sedang muat peluang…",
    "opp.back_home":     "Kembali ke laman utama",

    // Enquiry form
    "enq.title":         "Minta panggilan balik",
    "enq.name":          "Nama anda*",
    "enq.phone":         "Nombor WhatsApp*",
    "enq.email":         "Emel (pilihan)",
    "enq.message":       "Ada apa-apa yang kami patut tahu? (pilihan)",
    "enq.opt_buy":       "Saya nak Beli",
    "enq.opt_affiliate": "Jadi Afiliasi",
    "enq.opt_agent":     "Jadi Ejen",
    "enq.opt_stockist":  "Jadi Stockist",
    "enq.opt_general":   "Pertanyaan umum",
    "enq.submit":        "Minta callback dari",
    "enq.submitting":    "Menghantar…",
    "enq.err_required":  "Sila masukkan nama dan nombor telefon anda.",
    "enq.done_title":    "Pertanyaan diterima",
    "enq.done_sub":      "Pasukan kami akan hubungi anda di WhatsApp dalam beberapa minit.",
    "enq.done_toast":    "Terima kasih! Kami akan hubungi anda di WhatsApp tidak lama lagi.",
    "enq.footer":        "Atau tekan mana-mana butang di atas untuk WhatsApp kami serta-merta.",

    // Income calculator
    "calc.title":        "Anggar Pendapatan Anda",
    "calc.retail":       "Harga runcit",
    "calc.cost":         "Kos anda",
    "calc.units":        "Unit terjual / hari",
    "calc.profit_unit":  "Untung / unit",
    "calc.daily":        "Anggaran Harian",
    "calc.monthly":      "Anggaran Bulanan",

    // Landing page — misc sections
    "about.tag":         "Tentang",
    "about.cta":         "Ketahui lebih lanjut",
    "categories.tag":    "Kategori",
    "categories.heading":"Kategori bisnes",
    "categories.intro":  "Setiap jenis bisnes Malaysia — pilih sektor yang sesuai dengan kepakaran anda.",
    "journey.tag":       "Perjalanan anda",
    "journey.heading":   "Perjalanan usahawan MIRESCO",
    "journey.intro":     "Enam peringkat jelas — dari income tambahan ke pemimpin bisnes.",
    "programs.tag":      "Program",
    "programs.heading":  "Setiap persona ada tempat.",
    "programs.intro":    "Siapa pun anda, MIRESCO ada jalan pertumbuhan untuk anda.",
    "membership.tag":    "Keahlian",
    "membership.heading":"Pilih tier · buka faedah",
    "membership.intro":  "Dari Explorer percuma hingga Ambassador premium — berkembang dengan tier yang sepadan dengan cita-cita anda.",
    "coverage.tag":      "Liputan",
    "coverage.heading":  "Semua 16 negeri Malaysia",
    "coverage.intro":    "MIRESCO merangkumi setiap negeri di Malaysia — cari peluang di kawasan anda.",
    "coming.tag":        "Akan datang",
    "coming.heading":    "Ada perkara menarik akan datang",
    "final.tag":         "Sedia?",
    "final.heading":     "Mula buat duit dengan MIRESCO hari ini.",
    "final.sub":         "Sertai ribuan rakyat Malaysia yang menukar cita-cita menjadi pendapatan.",
    "final.cta_primary": "Sertai Percuma",
    "final.cta_secondary":"Chat di WhatsApp",

    // Footer
    "footer.tagline":    "Platform pembangunan usahawan Malaysia",
    "footer.rights":     "Hak cipta terpelihara.",

    // Journey Detail
    "jd.back":            "Dashboard",
    "jd.journey":         "perjalanan",
    "jd.guided":          "Perjalanan Berpandu",
    "jd.days":            "hari",
    "jd.progress":        "Kemajuan",
    "jd.reward":          "Ganjaran",
    "jd.reward_step":     "Ganjaran",
    "jd.mark_done":       "Tandakan selesai",
    "jd.saving":          "Menyimpan…",
    "jd.open":            "Buka",
    "jd.watch":           "Tonton",
    "jd.download":        "Muat turun",
    "jd.send_wa":         "Hantar WhatsApp",
    "jd.step_done_toast": "Langkah selesai — teruskan!",
    "jd.not_found":       "Perjalanan tidak dijumpai",
    "jd.loading":         "Sedang muat perjalanan…",
    "jd.back_dashboard":  "Kembali ke dashboard",

    // PWA install prompt
    "pwa.install_title": "Pasang MIRESCO pada telefon anda",
    "pwa.install_sub":   "Akses lebih pantas, boleh guna offline, satu-tekanan buka.",
    "pwa.install_cta":   "Tambah ke Skrin Utama",
    "pwa.dismiss":       "Tutup",
    "pwa.ios_sub":       "Tambah MIRESCO ke Skrin Utama untuk akses satu tekanan.",
    "pwa.ios_step_1":    "Tekan Share",
    "pwa.ios_step_2":    "Tekan Add to Home Screen",
    "pwa.ios_step_3":    "Tekan Add · Siap!",

    "cta.start_earning": "Mula Buat Duit",

    "side.dashboard":     "Dashboard",
    "side.tv":            "Opportunity TV",
    "side.opportunities": "Peluang",
    "side.applications":  "Permohonan",
    "side.territories":   "Wilayah",
    "side.influencers":   "Influencer",
    "side.membership":    "Keahlian",
    "side.notifications": "Notifikasi",
    "side.post_promo":    "Hantar Promo",
    "side.profile":       "Profil",
    "side.admin":         "Admin",
    "side.logout":        "Log Keluar",
    "side.portals":       "Portal",
  },
};

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  // Persist user's language choice in localStorage
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("miresco_lang") || "en"; } catch { return "en"; }
  });

  useEffect(() => {
    try { localStorage.setItem("miresco_lang", lang); } catch { /* private mode */ }
    document.documentElement.setAttribute("lang", lang === "ms" ? "ms-MY" : "en");
  }, [lang]);

  const t = (key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key;

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useT = () => useContext(LangCtx);

export function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useT();
  return (
    <div className="inline-flex items-center gap-1 border border-zinc-200 bg-white" data-testid="language-switcher" aria-label="Language">
      <span className="pl-2 pr-1 text-zinc-400" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 0 20M12 2a15.3 15.3 0 0 0 0 20"/></svg>
      </span>
      <button
        onClick={() => setLang("en")}
        data-testid="lang-en"
        aria-pressed={lang === "en"}
        className={`px-2.5 py-1 text-xs font-bold tracking-wide ${lang === "en" ? "bg-[#C8102E] text-white" : "text-zinc-600 hover:text-zinc-900"}`}
      >EN</button>
      <button
        onClick={() => setLang("ms")}
        data-testid="lang-ms"
        aria-pressed={lang === "ms"}
        className={`px-2.5 py-1 text-xs font-bold tracking-wide ${lang === "ms" ? "bg-[#C8102E] text-white" : "text-zinc-600 hover:text-zinc-900"}`}
      >BM</button>
    </div>
  );
}
